export enum TypeReduction {
     pourcentage = 1,
     montant = 2
}
